import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Pencil, Check } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";

const LABELS = ["My Why", "Who It's For", "Freedom Looks Like"];

export const PurposeRow = () => {
  const [items, setItems] = useState(["", "", ""]);
  const [editing, setEditing] = useState(-1);
  const [draft, setDraft] = useState("");

  useEffect(() => {
    api.get("/purpose").then((r) => setItems(r.data.items)).catch((err) => console.error("Purpose load failed:", err));
  }, []);

  const save = async (i) => {
    const next = [...items];
    next[i] = draft;
    try {
      await api.put("/purpose", { items: next });
      setItems(next);
      setEditing(-1);
      toast.success("Purpose saved");
    } catch { toast.error("Couldn't save purpose"); }
  };

  return (
    <section className="max-w-7xl mx-auto px-6 pt-10" data-testid="purpose-section">
      <p className="text-[10px] tracking-[0.5em] uppercase text-[#D4AF37] mb-4" data-testid="purpose-eyebrow">My Purpose</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {LABELS.map((label, i) => (
          <motion.div
            key={label} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.08 * i }}
            className="border border-white/10 rounded-md bg-[#0F0F11] p-5 min-h-32 flex flex-col"
            data-testid={`purpose-box-${i}`}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-[9px] uppercase tracking-[0.3em] text-zinc-500">{label}</span>
              {editing === i ? (
                <button onClick={() => save(i)} className="text-emerald-400 hover:text-emerald-300 transition-colors duration-200" data-testid={`purpose-save-${i}`}>
                  <Check className="w-4 h-4" />
                </button>
              ) : (
                <button onClick={() => { setEditing(i); setDraft(items[i]); }} className="text-zinc-600 hover:text-[#D4AF37] transition-colors duration-200" data-testid={`purpose-edit-${i}`}>
                  <Pencil className="w-3.5 h-3.5" />
                </button>
              )}
            </div>
            {editing === i ? (
              <Textarea
                value={draft} onChange={(e) => setDraft(e.target.value)} rows={3} autoFocus
                className="bg-white/5 border-white/10 text-white rounded-sm text-sm focus-visible:ring-[#D4AF37]"
                data-testid={`purpose-input-${i}`}
              />
            ) : (
              <p className={`text-sm leading-relaxed ${items[i] ? "text-zinc-200" : "text-zinc-600 italic"}`} data-testid={`purpose-text-${i}`}>
                {items[i] || "Write your why…"}
              </p>
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
};
